/**
 * Pilot progress bar component.
 */
import EpgEvent from '@shared/classes/epgEvent';
import ProgressBarChannel from '@components/sections/progressBar/progressBarChannel';
import ProgressBarVod from '@components/sections/progressBar/progressBarVod';
import {
  PilotType,
  PilotProgressBarProps as Props,
} from '@shared/types/props/pilot';

/**
 * Renders the pilot progress bar component.
 * Displays the progress bar for the channel or the vod.
 *
 * @param {Props} props - The props for the pilot progress bar component.
 * @returns {JSX.Element} The pilot progress bar component.
 */
export default function PilotProgressBar({ event, display, type }: Props) {
  if (!display) return;
  return type === PilotType.CHANNEL ? (
    <ProgressBarChannel event={event as EpgEvent} />
  ) : type === PilotType.VOD ? (
    <ProgressBarVod />
  ) : null;
}
